import { c as _c } from "react/compiler-runtime";
import { type DateValue, parseDate } from '@internationalized/date';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import type { InputFieldProps } from '@/models/inputFields';
import { LocalizedDatePicker } from '../LocalizedDatePicker';
type DateFieldProps = InputFieldProps<Date | null>;
const dateToDateValue = (date?: Date | null): DateValue | null => {
  if (!date) return null;
  return parseDate(dayjs(date).format('YYYY-MM-DD'));
};
const dateValueToDate = (dateValue?: DateValue | null): Date | null => {
  if (!dateValue) return null;
  return new Date(Date.UTC(dateValue.year, dateValue.month - 1, dateValue.day));
};
export const DateField = t0 => {
  const $ = _c(10);
  const {
    value,
    onChange,
    readonly
  } = t0;
  let t1;
  const t2 = value ?? null;
  let t3;
  if ($[0] !== t2) {
    t3 = dateToDateValue(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  t1 = t3;
  const valueAsDateValue = t1;
  let t4;
  if ($[2] !== onChange) {
    t4 = newVal => {
      const date = dateValueToDate(newVal ?? null);
      const dateString = date ? date.toISOString() : undefined;
      onChange?.(dateString);
    };
    $[2] = onChange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = !!readonly;
  const t6 = !!readonly;
  const t7 = !readonly;
  let t8;
  if ($[4] !== t4 || $[5] !== t5 || $[6] !== t6 || $[7] !== t7 || $[8] !== valueAsDateValue) {
    t8 = <LocalizedDatePicker value={valueAsDateValue} onChange={t4} isReadOnly={t5} isDisabled={t6} showClearButton={t7} />;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = valueAsDateValue;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  return t8;
};